import { ReactNode, useState } from 'react'
import { Style } from 'react-motion'

import { ButtonInside, ButtonLoader, ButtonStyled } from './Button.style'

export interface ButtonProps {
  appearance:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'primary_empty'
    | 'gray_empty'
    | 'orange_empty'
    | 'primary_empty_gray'
  width?: string
  position?: string
  children: ReactNode
  clickCallback?: () => void
  fontSize?: number
  lineHeight?: number
  padding?: number
  style?: Style
  margin?: boolean
  disabled?: boolean
}

export const Button = ({
  children,
  clickCallback = () => {},
  appearance,
  width,
  position,
  fontSize,
  lineHeight,
  padding,
  style,
  margin = true,
  disabled = false,
}: ButtonProps) => {
  const [loading, setLoading] = useState(false)
  return (
    <ButtonStyled
      onClick={async (e) => {
        e.preventDefault()
        e.stopPropagation()
        setLoading(true)
        if (!disabled) {
          await clickCallback()
        }
        setLoading(false)
      }}
      appearance={appearance}
      width={width}
      fontSize={fontSize}
      padding={padding}
      style={style}
      margin={margin}
      disabled={disabled}
    >
      <ButtonInside appearance={appearance} position={position}>
        {!loading && <span>{children}</span>}
        {loading && (
          <span>
            <ButtonLoader src={'/images/button-loader.png'} alt="Loader" />
          </span>
        )}
      </ButtonInside>
    </ButtonStyled>
  )
}
